export const NAVIGATION_BAR_HEIGHT = 50;
export const TAB_BAR_HEIGHT = 50;